/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './expireTime.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';


const ExpireTime: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const miliseconds = Number(activeManageOrder?.reservation_expiry_time);
    const expiryTime = new Date(miliseconds).toLocaleDateString();
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.expire_time}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h4>Expiry time:</h4>
            <span>{expiryTime}</span>
        </div>
    )
}

export default ExpireTime;